import * as React from "react";
import {Fragment} from "react";
import Card from "../Card/Card";

class Aside extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {

		const {title, children} = this.props;

		return (
			<Fragment>
				<Card>
					<div className="text-muted">
						<span className="d-block h6 pb-3 border-light border-bottom mb-3">
						{title}
					</span>
						{children}
					</div>
				</Card>
			</Fragment>
		);
	}
}

export default Aside;
